export enum IntegrationsType {
    Tracker = 'tracker',
    Email = 'email',
    Wiki = 'wiki',
    Jsonrpc = 'jsonrpc',
    Post = 'post',
    Put = 'put',
    Http = 'http',
    Function = 'function',
}

export enum IntegrationsStatus {
    Pending = 'pending',
    Error = 'error',
    Success = 'success',
    Canceled = 'canceled',
}
